module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.authentication.signup', {
            url: '/signup?id&token',
            params: {
                toState: null,
                toStateParams: null,
                toStateOptions: { reload: false },
                customCallback: null,
            },
            views: {
                'center-panel': {
                    controller: [
                        '$scope', '$state', '$stateParams', '$timeout', function ($scope, $state, $stateParams, $timeout) {
                            $scope.$on('signup:success', () => {
                                if ($stateParams.customCallback) {
                                    $stateParams.customCallback();
                                } else {
                                    // Redirect with a page load in a timeout to make sure other 'signup:success'
                                    // handlers also get to run
                                    $timeout(() => {
                                        window.location.href = $stateParams.toState
                                            ? $state.href($stateParams.toState.name || $stateParams.toState, $stateParams.toStateParams, $stateParams.toStateOptions) || '/'
                                            : '/';
                                    }, 0, false);
                                }
                            });
                        },
                    ],
                    template: '<wow-signup-page></wow-signup-page>',
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/authentication-signup.js